export const FOUNDEND_SMART_SEARCH = 'FOUNDEND_SMART_SEARCH';
